import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';

export default function WerkgebiedPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const cities = [
    { name: 'Utrecht', schiphol: 55, rotterdam: 75, eindhoven: 95 },
    { name: 'Nieuwegein', schiphol: 57.50, rotterdam: 77.50, eindhoven: 97.50 },
    { name: 'De Meern', schiphol: 52.50, rotterdam: 72.50, eindhoven: 92.50 },
    { name: 'Maarssen', schiphol: 57.50, rotterdam: 77.50, eindhoven: 97.50 },
    { name: 'Houten', schiphol: 60, rotterdam: 80, eindhoven: 100 },
    { name: 'Zeist', schiphol: 62.50, rotterdam: 82.50, eindhoven: 102.50 },
    { name: 'Soest', schiphol: 65, rotterdam: 85, eindhoven: 105 },
    { name: 'Vianen', schiphol: 60, rotterdam: 70, eindhoven: 95 },
    { name: 'IJsselstein', schiphol: 57.50, rotterdam: 72.50, eindhoven: 97.50 },
    { name: 'Breukelen', schiphol: 52.50, rotterdam: 77.50, eindhoven: 97.50 },
    { name: 'Harmelen', schiphol: 52.50, rotterdam: 72.50, eindhoven: 92.50 },
    { name: 'Vleuten', schiphol: 52.50, rotterdam: 72.50, eindhoven: 92.50 },
    { name: 'Woerden', schiphol: 57.50, rotterdam: 75, eindhoven: 95 }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} />

      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/0744f4f5262a408f52cbaa7bc8b6fb90.jpg')] bg-cover bg-center"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Ons Werkgebied: Heel Regio Utrecht
          </h1>
          <p className="text-xl text-slate-300 mb-8 leading-relaxed max-w-3xl mx-auto">
            Utrecht Airport Taxi verzorgt luchthaventritten vanuit alle plaatsen in de regio Utrecht. Vaste prijzen, 24/7 beschikbaar, altijd betrouwbaar.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Vaste Prijzen per Plaats</h2>
            <p className="text-xl text-slate-600">Selecteer uw vertrekplaats voor gedetailleerde informatie en prijzen</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cities.map((city) => (
              <div key={city.name} className="bg-white border-2 border-slate-200 rounded-2xl p-6 hover:border-amber-500 hover:shadow-lg transition-all">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold text-slate-900">{city.name}</h3>
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-line text-2xl text-amber-600"></i>
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  <div className="flex items-center justify-between py-2 border-b border-slate-100">
                    <span className="text-slate-600">→ Schiphol</span>
                    <span className="font-bold text-slate-900">€{city.schiphol.toFixed(2)}</span>
                  </div>
                  <div className="flex items-center justify-between py-2 border-b border-slate-100">
                    <span className="text-slate-600">→ Rotterdam</span>
                    <span className="font-bold text-slate-900">€{city.rotterdam.toFixed(2)}</span>
                  </div>
                  <div className="flex items-center justify-between py-2">
                    <span className="text-slate-600">→ Eindhoven</span>
                    <span className="font-bold text-slate-900">€{city.eindhoven.toFixed(2)}</span>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-2">
                  <Link 
                    to={`/taxi-${city.name.toLowerCase()}-schiphol`}
                    className="px-3 py-2 bg-slate-100 text-slate-700 rounded-lg text-sm font-medium hover:bg-amber-500 hover:text-white transition-colors text-center whitespace-nowrap"
                  >
                    Schiphol
                  </Link>
                  <Link 
                    to={`/taxi-${city.name.toLowerCase()}-rotterdam-airport`}
                    className="px-3 py-2 bg-slate-100 text-slate-700 rounded-lg text-sm font-medium hover:bg-amber-500 hover:text-white transition-colors text-center whitespace-nowrap"
                  >
                    Rotterdam
                  </Link>
                  <Link 
                    to={`/taxi-${city.name.toLowerCase()}-eindhoven-airport`}
                    className="px-3 py-2 bg-slate-100 text-slate-700 rounded-lg text-sm font-medium hover:bg-amber-500 hover:text-white transition-colors text-center whitespace-nowrap"
                  >
                    Eindhoven
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 mb-8 text-center">Waarom Lokale Taxi Kiezen?</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-map-2-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Kennis van de Regio</h3>
              <p className="text-slate-700 leading-relaxed">
                Onze chauffeurs kennen de regio Utrecht als hun broekzak. Wij weten welke routes het snelst zijn en hoe wij files kunnen vermijden.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Altijd op Tijd</h3>
              <p className="text-slate-700 leading-relaxed">
                Punctualiteit is onze prioriteit. Wij zorgen dat u ruim op tijd op het vliegveld aankomt, zonder stress of haast.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Persoonlijke Service</h3>
              <p className="text-slate-700 leading-relaxed">
                Als lokaal bedrijf staan wij dicht bij onze klanten. Vragen of speciale wensen? Wij denken graag met u mee.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Betrouwbaar & Veilig</h3>
              <p className="text-slate-700 leading-relaxed">
                Alle chauffeurs zijn professioneel, gecertificeerd en rijden in goed onderhouden voertuigen. Uw veiligheid staat voorop.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-slate-900 mb-6">Direct Reserveren?</h2>
          <p className="text-xl text-slate-600 mb-8">
            Bereken uw prijs en boek direct online. Of bel ons voor persoonlijk advies.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/prijs-berekenen" className="px-8 py-4 bg-amber-500 text-white rounded-lg font-semibold hover:bg-amber-600 transition-colors whitespace-nowrap">
              Prijs Berekenen
            </Link>
            <a href="tel:+31612345678" className="px-8 py-4 bg-slate-900 text-white rounded-lg font-semibold hover:bg-slate-800 transition-colors whitespace-nowrap">
              <i className="ri-phone-line mr-2"></i>06 1234 5678
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
